<template>
  <div
    class="relative inline-block text-left cursor-pointer "
    :class="[classes]"
    @focusout="closeWithTimeout"
  >
    <div
      class="menu-button inline-flex w-full h-full gap-x-1.5 items-center"
      aria-expanded="true"
      aria-haspopup="true"
      tabindex="-1"
      @click.stop="showItems()"
      :class="{
        itemsAreVisible,
        bigZIndex,
        'pointer-events-none': itemsAreVisible,
      }"
    >
      <slot></slot>

      <svg
        v-if="!hideArrow"
        class="mx-1 min-w-5 h-5 w-5 text-primary-400 my-auto"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <div class="h-0 w-0 relative overflow-hidden">
      <div
        class="absolute w-[max-content] min-w-[150px] pointer-events-none"
        ref="dropDownPositionFinder"
        :class="{
          'bottom-[100%]': dropdownPosition == 'top',
          'left-0': !toLeft,
          'right-0': toLeft,
        }"
        :style="{
          height: dropdownHeight,
          width: dropdownWidth,
        }"
      ></div>
    </div>
    <div
      ref="dropdown"
      class="duration-300 ease-in-out fixed overflow-auto z-10 mt-2 w-[max-content] rounded-md bg-[#FBFBFC]  bodyBg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      :style="{
        maxHeight,
        maxWidth,
        minWidth,
        top: dropdownPositionTop,
        left: dropdownPositionLeft,
      }"
      :class="{
        'origin-top-left': !toLeft & (dropdownPosition == 'bottom'),
        'origin-top-right': toLeft & (dropdownPosition == 'bottom'),
        'origin-bottom-left': !toLeft & (dropdownPosition == 'top'),
        'origin-bottom-right': toLeft & (dropdownPosition == 'top'),
      }"
    >
      <div class="py-1" role="none">
        <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
        <div
          class="flex text-specials-dropdownTextColor px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
          role="menuitem"
          :key="i"
          @click.stop="
            () => {
              onSelect(item);
              itemsAreVisible = false;
            }
          "
          v-for="(item, i) in selects"
        >
          <slot name="item" :data="{ item, index: i }">
            <div>
              <div
                v-html="
                  displayKey && item[displayKey] ? item[displayKey] : item
                "
              ></div>
            </div>
            <span
              class="ml-auto my-auto"
              v-show="
                selectedValue ==
                  (displayKey && item[displayKey] ? item[displayKey] : item)
              "
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                class="w-3 fill-primary"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M4473 4540 c-126 -26 -51 43 -1423 -1326 l-1275 -1274 -480 480 c-518 518 -529 527 -657 551 -51 9 -79 9 -124 1 -113 -23 -158 -53 -306 -200 -114 -115 -142 -149 -170 -207 -30 -64 -33 -78 -33 -165 0 -83 4 -103 29 -160 28 -61 77 -113 799 -837 556 -557 784 -779 821 -800 71 -39 168 -39 241 -1 38 20 432 409 1606 1585 1481 1483 1557 1561 1585 1623 25 57 29 77 29 160 0 137 -27 191 -176 345 -126 130 -187 179 -257 205 -59 22 -154 31 -209 20z"
                  />
                </g>
              </svg>
            </span>
          </slot>
        </div>
      </div>
    </div>
    <ModalComponent
    ref="modal"
      iconLeftBg="#00f2"
      :onPrimaryClick="
        () => {
          manualySubmitForm();
        }
      "
      :onOverlayClick="
        () => {
          onDismissClick();
        }
      "
      :onCancelClick="
        () => {
          onDismissClick();
        }
      "
      :onBackButtonClick="
        () => {
          onDismissClick();
        }
      "
      :primaryButtonLoading="false"
    >
      <template #titleText>
        <div class="max-w-full w-[450px] font-bold title-color">
          {{ title }}
        </div>
      </template>
      <template #subtitleText>
        <div class="max-w-full w-[450px]">
          {{ subTitle }}
        </div>
      </template>

      <div class="h-[80svh]">
        <div
          class="flex text-specials-dropdownTextColor px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
          role="menuitem"
          :key="i"
          @click.stop="
            () => {
              onSelect(item);
              endPrompt();
            }
          "
          v-for="(item, i) in selects"
        >
          <slot name="item" :data="{ item, index: i }">
            <div class="w-full">
              <div
                v-html="
                  displayKey && item[displayKey] ? item[displayKey] : item
                "
              ></div>
            </div>
            <span
              class="ml-auto my-auto"
              v-show="
                !hideSelectedCheck && selectedValue ==
                  (displayKey && item[displayKey] ? item[displayKey] : item)
              "
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                class="w-3 fill-primary"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M4473 4540 c-126 -26 -51 43 -1423 -1326 l-1275 -1274 -480 480 c-518 518 -529 527 -657 551 -51 9 -79 9 -124 1 -113 -23 -158 -53 -306 -200 -114 -115 -142 -149 -170 -207 -30 -64 -33 -78 -33 -165 0 -83 4 -103 29 -160 28 -61 77 -113 799 -837 556 -557 784 -779 821 -800 71 -39 168 -39 241 -1 38 20 432 409 1606 1585 1481 1483 1557 1561 1585 1623 25 57 29 77 29 160 0 137 -27 191 -176 345 -126 130 -187 179 -257 205 -59 22 -154 31 -209 20z"
                  />
                </g>
              </svg>
            </span>
          </slot>
        </div>
      </div>
<!-- 
      <template #primaryButton v-if="successText">
        {{ successText }}
      </template>
      <template #cancelButton v-if="cancelText">
        {{ cancelText }}
      </template> -->
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ModalComponent from "./ModalComponent.vue";

export default defineComponent({
  name: "Dropdown",
  components: { ModalComponent },
  props: {
    classes: {
      type: String,
      default: "",
    },
    selectedValue: {
      type: String,
      default: "",
    },
    maxHeight: {
      type: String,
      default: "300px",
    },
    maxWidth: {
      type: String,
      default: "350px",
    },
    minWidth: {
      type: String,
      default: "150px",
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    toLeft: {
      type: Boolean,
      default: false,
    },
    useModal: {
      type: Boolean,
      default: false,
    },
    hideSelectedCheck: {
      type: Boolean,
      default: false,
    },
    selects: {
      type: Array,
      default: () => {
        return ["none"];
      },
    },
    displayKey: {
      type: String,
      default: "",
    },
    dropdownPosition: {
      type: String,
      default: "bottom",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    onSelect: {
      type: Function,
      default: (selected) => {
        console.log(selected);
      },
    },
    initDropdownFunctions: {
      type: Function,
      default: (showDropdown, hideDropdown) => {},
    },
  },
  data() {
    return {
      itemsAreVisible: false,
      bigZIndex: false,
      dropdownPositionTop: "auto",
      dropdownPositionLeft: "auto",
      dropdownHeight: "auto",
      dropdownWidth: "auto",
    };
  },
  mounted() {
    this.initDropdownFunctions(
      () => {
        this.itemsAreVisible = true;
      },
      () => {
        this.itemsAreVisible = false;
      }
    );
    this.computeDropdownPosition();
    setTimeout(this.computeDropdownPosition, 500);
    setTimeout(this.computeDropdownPosition, 1000);
    // window.addEventListener("scrollend", this.computeDropdownPosition, true);
    window.addEventListener("scroll", this.computeDropdownPosition, true);
  },
  unmounted() {
    // window.removeEventListener("scrollend", this.computeDropdownPosition, true);
    window.removeEventListener("scroll", this.computeDropdownPosition, true);
  },
  methods: {
    showItems() {
      if (this.useModal) {
        this.showModalPrompt();
        return;
      }
      this.computeDropdownPosition();
      this.bigZIndex = true;
      this.itemsAreVisible = true;
      setTimeout(() => {
        this.itemsAreVisible = true;
      }, 100);
    },
    closeWithTimeout() {
      this.bigZIndex = false;
      setTimeout(() => {
        this.itemsAreVisible = false;
      }, 250);
    },
    computeDropdownPosition() {
      if (!this.$refs.dropdown) return;
      const dropdownHeight = this.$refs.dropdown.offsetHeight;
      const dropdownWidth = this.$refs.dropdown.offsetWidth;
      const bodyHeight = document.body.offsetHeight;
      const bodyWidth = document.body.offsetWidth;

      let dropdownPositionTop = this.getDropdownPosition("top");
      let dropdownPositionLeft = this.getDropdownPosition("left");

      if (dropdownPositionTop < 10) dropdownPositionTop = 10;
      if (dropdownPositionLeft < 10) dropdownPositionLeft = 10;
      if (dropdownPositionTop + dropdownHeight > bodyHeight)
        dropdownPositionTop = bodyHeight - dropdownHeight - 10;
      if (dropdownPositionLeft + dropdownWidth > bodyWidth)
        dropdownPositionLeft = bodyWidth - dropdownWidth - 10;

      this.dropdownPositionTop = dropdownPositionTop + "px";
      this.dropdownPositionLeft = dropdownPositionLeft + "px";
      this.dropdownHeight = dropdownHeight + "px";
      this.dropdownWidth = dropdownWidth + "px";
    },
    getDropdownPosition(position) {
      const dropDownPositionFinder = this.$refs.dropDownPositionFinder;
      if (!dropDownPositionFinder) return "auto";
      const elementRect = dropDownPositionFinder.getBoundingClientRect();
      return elementRect[position] || 0;
    },

    showModalPrompt() {
      this.$refs.modal.show()
    },
    hideModalPrompt() {
      this.$refs.modal.hide()
    },
    modalPromptIsVisible() {
      return this.$refs.modal.isVisible()
    },
    manualySubmitForm() {
      console.log("function manualySubmitForm not set ");
      return false;
    },
    onFormSubmited(data) {
      this.endPrompt(true, data);
    },
    onDismissClick() {
      this.endPrompt();
    },
    endPrompt(promptAccepted, data = {}) {
      this.hideModalPrompt();
    },
  },
  watch: {},
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-button ~ [role="menu"] {
  opacity: 0;
  pointer-events: none;
  transform: scale(0.8);
  z-index: 1000;
}

.menu-button.itemsAreVisible ~ [role="menu"] {
  opacity: 1;
  pointer-events: all;
  transform: scale(1);
}

.menu-button.bigZIndex ~ [role="menu"] {
  z-index: 100000;
}
</style>
